import deepmerge from 'deepmerge'
import { ACTION_TYPES } from '~/core/constants'

const { SCREENSHOTS } = ACTION_TYPES
const initialState = {
  map: {}
}

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case SCREENSHOTS.FETCHING_IN_PROGRESS: {
      return {
        ...state,
        map: deepmerge(state.map, {
          [action.payload.sessionId]: {
            fetchingInProgress: action.payload.value
          }
        })
      }
    }
    case SCREENSHOTS.FETCHED_SCREENSHOTS: {
      return {
        ...state,
        map: deepmerge(state.map, action.payload)
      }
    }
    case SCREENSHOTS.PURGE_SCREENSHOT_DATA: {
      const updatedMap = { ...state.map }
      delete updatedMap[action.payload.sessionId]

      return {
        ...state,
        map: updatedMap
      }
    }
    case SCREENSHOTS.SET_SELECTED_SCREENSHOT: {
      return {
        ...state,
        map: deepmerge(state.map, {
          [action.payload.sessionId]: {
            selectedScreenshotId: action.payload.screenshotId
          }
        })
      }
    }
    default:
      return state
  }
}

export default reducer
